import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { withBasePath } from '../utils/paths.js';

function FooterBlock({ id, title, links }) {
  return (
    <section className="footer-block" aria-labelledby={id}>
      <h3 id={id} className="footer-block__title">
        {title}
      </h3>
      <ul className="footer-block__list">
        {links.map((link) => (
          <li key={link.to + link.label}>
            <Link to={link.to}>{link.label}</Link>
          </li>
        ))}
      </ul>
    </section>
  );
}

const PASSENGERS = [
  { to: '/flight-information', label: 'Flight information' },
  { to: '/arrival-guide', label: 'Arrival guide' },
  { to: '/departure-guide', label: 'Departure guide' },
  { to: '/transport', label: 'Transport & parking' },
  { to: '/airport-map', label: 'Airport map' },
  { to: '/special-assistance', label: 'Special assistance' },
];

const SERVICES = [
  { to: '/lounges', label: 'Lounges' },
  { to: '/dining', label: 'Dining' },
  { to: '/shopping', label: 'Shopping' },
  { to: '/hotels', label: 'Hotels' },
  { to: '/faqs', label: 'FAQs' },
  { to: '/contact', label: 'Contact us' },
];

const BUSINESS = [
  { to: '/business', label: 'Business' },
  { to: '/cargo', label: 'Cargo and freight' },
  { to: '/news', label: 'News' },
  { to: '/corporate', label: 'About Afroport' },
];

const LEGAL = [
  { to: '/terms-of-use', label: 'Terms of use' },
  { to: '/privacy-policy', label: 'Privacy policy' },
  { to: '/accessibility', label: 'Accessibility' },
  { to: '/cookies', label: 'Cookie policy' },
];

const SOCIAL_LINKS = [
  {
    label: 'Facebook',
    href: 'https://web.facebook.com/AfroportMauritanie',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
      </svg>
    ),
  },
  {
    label: 'LinkedIn',
    href: 'https://www.linkedin.com/company/afroportnkc/',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6zM2 9h4v12H2z" />
        <circle cx="4" cy="4" r="2" />
      </svg>
    ),
  },
];

function SocialIcons() {
  return (
    <div className="footer-social-grid">
      {SOCIAL_LINKS.map(({ label, href, icon }) => (
        <a
          key={label}
          className="footer-social-icon"
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={label}
          title={label}
        >
          {icon}
        </a>
      ))}
    </div>
  );
}

export default function Footer() {
  const [year, setYear] = useState(new Date().getFullYear());

  useEffect(() => {
    setYear(new Date().getFullYear());
  }, []);

  return (
    <footer className="site-footer site-footer--compact" role="contentinfo">
      <div className="site-footer__upper">
        <div className="container site-footer__grid">
          <FooterBlock id="ff-passengers" title="Passengers" links={PASSENGERS} />
          <FooterBlock id="ff-services" title="Services" links={SERVICES} />
          <FooterBlock id="ff-business" title="Business" links={BUSINESS} />
          <FooterBlock id="ff-legal" title="Legal" links={LEGAL} />

          <aside className="site-footer__aside" aria-label="Social and disclaimer">
            <div className="footer-aside__block">
              <p className="footer-aside__label">Follow us</p>
              <SocialIcons />
            </div>
            <div className="footer-aside__block footer-aside__disclaimer">
              <p className="footer-aside__label">Disclaimer</p>
              <p className="footer-aside__disclaimer-text" role="note">
                Airport and flight information on this website is provided for general guidance only
                and may change without notice. Information may occasionally be incomplete, outdated,
                or incorrect. Always confirm details with your airline or the relevant authority
                before travelling. Where flight times are shown, they are in{' '}
                <abbr title="Greenwich Mean Time">GMT</abbr> (Nouakchott).
              </p>
            </div>
          </aside>
        </div>
      </div>

      <div className="site-footer__bar">
        <div className="container site-footer__bar-inner">
          <div className="site-footer__bar-brand">
            <Link to="/">
              <img
                src={withBasePath('/assets/logo.png')}
                alt="Afroport Mauritanie SARL"
                className="logo__img logo__img--footer"
                width="160"
                height="40"
              />
            </Link>
          </div>
          <p className="site-footer__copy">
            &copy; {year} Afroport Mauritanie SARL, operator of Nouakchott Oumtounsy International
            Airport (NKC/GQNO)
          </p>
        </div>
      </div>
    </footer>
  );
}
